import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyIncomingCall = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-incoming-call", jiraSpaEntry: "async-jira-eoc-incoming-call" */ '@atlassian/jira-eoc-incoming-call'
	).then((module) => module.IncomingCallPage),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyIncomingCallDetail = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-incoming-call-integration-detail", jiraSpaEntry: "async-jira-eoc-incoming-call-integration-detail" */ '@atlassian/jira-eoc-incoming-call'
	).then((module) => module.IncomingCallDetailPage),
);
